import { render, staticRenderFns } from "./priceList.vue?vue&type=template&id=65f71ac8&scoped=true&"
import script from "./priceList.vue?vue&type=script&lang=js&"
export * from "./priceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f71ac8",
  null
  
)

export default component.exports